import { BRAND, NAV_LINKS, SOCIALS } from "@/data/site";

const Footer = () => {
  const go = (href) => {
    if (href.startsWith("/#")) {
      const id = href.slice(2);
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="border-t border-white/8 bg-navy-950 py-10">
      <div className="container-x flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-right">
        <div>
          <p className="flex items-center justify-center gap-2 font-en text-lg font-extrabold md:justify-start">
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-teal-400" />
            {BRAND.en}
          </p>
          <p className="mt-1 text-xs text-ink-mute">{BRAND.tagline}</p>
        </div>

        <nav className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-ink-soft">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`footer-link-${l.label}`}
              onClick={() => go(l.href)}
              className="min-h-[44px] transition hover:text-teal-400"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {SOCIALS.map((s) => (
            <a
              key={s.name}
              href={s.href}
              aria-label={s.name}
              data-testid={`footer-social-${s.name}`}
              className="flex h-11 w-11 items-center justify-center rounded-full bg-white/5 text-ink-soft transition hover:bg-teal-500/15 hover:text-teal-300"
            >
              <s.icon className="h-5 w-5" />
            </a>
          ))}
        </div>
      </div>
      <p className="container-x mt-8 border-t border-white/5 pt-6 text-center text-xs text-ink-mute">
        © {new Date().getFullYear()} {BRAND.en} — جميع الحقوق محفوظة
      </p>
    </footer>
  );
};

export default Footer;
